import styled from 'styled-components'
import { Alert } from '@elparking/components'

export default styled(Alert)`
    margin-bottom: 0.5em;
`
